import sendEvent from '../helpers/sendEvent';

const videoEvents = () => {
  const convert = event => ({
    /* eslint-disable camelcase */
    data_nodeId: event.page.page_id || '0',
    data_videoType: event.video.video_type,
    data_videoAd: event.event === 'ad_begin' ? 1 : '0',
    data_creativeId: event.ad.ad_id || '0',
    data_videoDuration: event.video.video_duration || '0',
    data_videoPosition: event.video.video_position || '0',
    data_videoVolume: event.video.video_player_volume || '0',
    data_videoMuted: event.video.video_player_volume !== 0 ? 1 : '0',
    data_videoFullscreen: event.video.video_view_mode,
    /* eslint-enable camelcase */
  });
  const eventMap = [
    'video_play',
    'video_ended',
    'ad_break_begin',
    'ad_break_end',
    'ad_begin',
    'ad_end',
  ];
  const originalPush = window.dataLayer.push;

  window.dataLayer.push = function(...args) {
    originalPush.apply(window.dataLayer, args);

    const event = args[0];
    if (event && eventMap.includes(event.event)) {
      sendEvent(event.event, convert(event));
    }
  };
};

export default videoEvents;
